import { Controller } from "@hotwired/stimulus"

// eslint-disable-next-line import/no-default-export
export default class extends Controller {
  static targets = ["menu", "overlay", "section", "openButton", "closeButton"]

  connect() {
    this.boundKeydown = this.keydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
    document.body.classList.remove("overflow-hidden")
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.overlayTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.boundKeydown)
    this.updateAriaExpanded(true)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.overlayTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.boundKeydown)
    this.updateAriaExpanded(false)
  }

  updateAriaExpanded(isOpen) {
    if (this.hasOpenButtonTarget) {
      this.openButtonTarget.setAttribute("aria-expanded", isOpen.toString())
    }
    if (this.hasCloseButtonTarget) {
      this.closeButtonTarget.setAttribute("aria-expanded", isOpen.toString())
    }
  }

  toggleSection(event) {
    const section = event.currentTarget.closest("[data-mobile-menu-target='section']")
    const content = section.querySelector("[data-section-content]")
    const chevron = section.querySelector("[data-section-chevron]")

    if (content.classList.contains("hidden")) {
      content.classList.remove("hidden")
      chevron.classList.add("rotate-90")
    } else {
      content.classList.add("hidden")
      chevron.classList.remove("rotate-90")
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
